import { useState, useEffect, useContext } from 'react'
import css from './productDetail.module.scss'
import { useNavigate } from 'react-router-dom'
import { useMixPanel } from '../../hooks/useMixPanel'
import { useGtag } from '../../hooks/useGtag'
import { toAbsoluteUrl } from '../../utils/assetHelper'
import { isVideoFile, getMp4Url, isGif } from '../../utils/videoHelper'
import { isValidURL } from '../../utils/urlHelper'
import { Tooltip as ReactTooltip } from "react-tooltip";
import { createCartApi, addItemsToCartApi } from '../../api'
import { AuthContext } from '../../context/auth'
import { setLocalStorage, getLocalStorage } from '../../helpers/localStorage'
import { getNestedValue, productFields } from '../../utils/productFields';
import { methodologyShortName } from '../../utils/methodology';

export const ProductDetails = ({
    selectedProduct,
    setSelectedProduct = () => { },
    setProductId = () => { },
    setModalName,
    setOpenMethodologyModal,
    isSlug=false
}) => {
    const cartId = getLocalStorage('cartId')
    const { setIsLoading, setNotification, setCartData, isLoading, setUpcomingPurchaseModal, setBulkOrderModal, tempDisable, setTempDisable, width } = useContext(AuthContext)
    const navigate = useNavigate()
    const galleryUrl = `${process.env.REACT_APP_GALLERY_URL}150:150`
    const { mixPanelEvent, mixPanelServerEvent } = useMixPanel()
    const { gtagViewDownloadEvent, gtagAddToCart } = useGtag()
    const [images, setImages] = useState([])
    const [imageSlideIndex, setImageSlideIndex] = useState(0)
    const [productTab, setProductTab] = useState("primary")

    useEffect(() => {
        if (selectedProduct?.mid_code.search("PA") >= 0) {
            setProductTab("primary")
        } else if (selectedProduct?.mid_code.search("DC") >= 0) {
            setProductTab("alexaflour")
        } else {
            setProductTab("")
        }

        if (selectedProduct?.metadata?.images) {
            const arr = selectedProduct?.metadata?.images?.filter((item) => item.url !== '')
            const splitArr = Array.from({ length: Math.ceil(arr.length / 4) }, (_, index) =>
                arr.slice(index * 4, index * 4 + 4)
            );
            setImages(splitArr)
        }

    }, [selectedProduct])

    const AddToCart = (selectedProduct) => {
        setIsLoading(true)
        if (!cartId) {
            createCartApi().then(res => {
                setLocalStorage('cartId', res.data.cart.id)
                addItemsToCartApi(res.data.cart.id, {
                    variant_id: selectedProduct?.variants[0]?.id,
                    quantity: 1,
                }).then((res) => {
                    if (res && res.data && res.data?.cart) {
                        setCartData(res.data.cart)
                        setNotification({
                            message: 'Added to cart',
                            type: 'green',
                        })
                        gtagAddToCart(res?.data?.cart?.subtotal, selectedProduct)
                        setIsLoading(false)
                    } else {
                        setNotification({
                            message: 'Something went wrong',
                            type: 'red',
                        })
                        setIsLoading(false)
                    }
                })
            })
        } else {
            addItemsToCartApi(cartId, {
                variant_id: selectedProduct?.variants[0]?.id,
                quantity: 1,
            }).then((res) => {
                if (res && res.data && res.data?.cart) {
                    setCartData(res.data.cart)
                    setNotification({
                        message: 'Added to cart',
                        type: 'green',
                    })
                    gtagAddToCart(res?.data?.cart?.subtotal, selectedProduct)
                    setIsLoading(false)
                } else {
                    setNotification({
                        message: 'Something went wrong',
                        type: 'red',
                    })
                    setIsLoading(false)
                }
            })
        }
    }

    return (
        <div className={css.productDetails}>
            <div className={css.product}>
                <>
                    <div className={`${css.row} ${css.backBtn}`}
                        onClick={() => {
                            setSelectedProduct(null)
                            setProductId(null)
                            setModalName(null)
                            setImageSlideIndex(0)
                            setImages([])
                        }}
                    >
                        <span className={css.navBtn}><i className='fas fa-chevron-left'></i></span>
                        Return to Products
                    </div>
                    <div className={css.productHeader}>
                        <div className={css.leftCol}>
                            <h4>{selectedProduct?.title}</h4>
                            <h5>Cat ID# - {selectedProduct?.mid_code} {selectedProduct?.material}</h5>
                        </div>
                        <div className={css.rightCol}>
                            {selectedProduct?.metadata?.coa &&
                                <span className={css.linkBtn} onClick={() => {
                                    window.open(selectedProduct?.metadata?.coa?.url, '_blank')
                                    const data = {
                                        product_id: selectedProduct?.id,
                                        cat_id: `${selectedProduct?.mid_code} ${selectedProduct?.material}`,
                                        product_name: selectedProduct?.title,
                                        file_url: selectedProduct?.metadata?.coa?.url
                                    }
                                    mixPanelEvent('COA', data)
                                    mixPanelServerEvent('COA', data)
                                    gtagViewDownloadEvent('coa', data)
                                }}>
                                    CoA
                                </span>
                            }
                            {selectedProduct?.metadata?.sds &&
                                <span className={css.linkBtn} onClick={() => {
                                    window.open(selectedProduct?.metadata?.sds?.url, '_blank')
                                    const data = {
                                        product_id: selectedProduct?.id,
                                        cat_id: `${selectedProduct?.mid_code} ${selectedProduct?.material}`,
                                        product_name: selectedProduct?.title,
                                        file_url: selectedProduct?.metadata?.sds?.url
                                    }
                                    mixPanelEvent('SDS', data)
                                    mixPanelServerEvent('SDS', data)
                                    gtagViewDownloadEvent('sds', data)
                                }}>
                                    SDS
                                </span>
                            }
                        </div>
                    </div>
                    <div className={css.divider} />
                    <div className={css.productInfo}>
                        {productFields.map((field, index) => {
                            const shouldShow = !field.condition || field.condition(productTab, selectedProduct);
                            if (!shouldShow) return null;

                            const rawValue = field.valueKey
                                ? getNestedValue(selectedProduct, field.valueKey)
                                : undefined;

                            const formattedValue = field.format
                                ? field.format(field.valueKey ? rawValue : selectedProduct)
                                : rawValue ?? '-';

                            const isLink = field.linkPrefix && rawValue;
                            const linkHref = isLink ? `${field.linkPrefix}${rawValue}${field.linkSuffix || ''}` : null;

                            return (
                                <div className={css.productRow} key={index}>
                                    <div className={css.col}>
                                        <h4>{field.label}</h4>
                                    </div>

                                    <div className={`${css.col} ${css.rightCol}`}>
                                        <h4 className={isLink ? 'external_link' : ''}>
                                            {isLink ? (
                                                <a
                                                    href={linkHref}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {rawValue}
                                                </a>
                                            ) : (
                                                formattedValue || '-'
                                            )}
                                        </h4>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className={css.divider} />
                    <div className={css.col}>
                        <h4>Applications</h4>
                        <div className={css.applicationContainer}>
                            {selectedProduct?.metadata?.protein_application?.map((item, index) => {
                                return <span key={index} className={css.linkBtn} onClick={() => {
                                    setModalName(item.name)
                                    if (isSlug) {
                                        navigate(`${window.location.pathname}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === item.name) || item.name}`)
                                    }                                    
                                    setOpenMethodologyModal(true)
                                }} data-tooltip-id="applications" data-tooltip-content={item.name}>{item.abbr}</span>
                            })
                            }
                            {selectedProduct?.metadata?.microscopy_application?.map((item, index) => {
                                return <span key={index} className={css.linkBtn} onClick={() => {
                                    setModalName(item.name)
                                     if (isSlug) {
                                        navigate(`${window.location.pathname}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === item.name) || item.name}`)
                                    }
                                    setOpenMethodologyModal(true)
                                }} data-tooltip-id="applications" data-tooltip-content={item.name}>{item.abbr}</span>
                            })
                            }
                        </div>
                    </div>
                    <div className={css.divider}>
                    </div>
                    <div className={css.col}>
                        {images && images.length > 0 && <div className={css.imagesContainer}>
                            {images[imageSlideIndex]?.map((item, index) => {
                                return <div className={css.image} onClick={() => {
                                     if (isSlug) {
                                        navigate(`${window.location.pathname}/${Object.keys(methodologyShortName).find(key => methodologyShortName[key] === item.name) || item.name}`)
                                    }
                                    setOpenMethodologyModal(true)
                                    setModalName(item.name)
                                }} key={index}>
                                    {isVideoFile(item) ?
                                        <video src={getMp4Url(item.url)} muted autoPlay loop playsInline /> :
                                        isGif(item) ?
                                            <img src={item.url} alt="" /> :
                                            <img src={galleryUrl + `:${item.url?.split('.com/')[1]}` || toAbsoluteUrl('/media/methodologyplaceholder.png')} alt="" />
                                    }
                                    <h6>{item.name}</h6>
                                </div>
                            })}
                        </div>
                        }
                        {images && images.length > 1 && <div className={css.paginationContainer}>
                            <button
                                className={css.navBtn}
                                onClick={() => {
                                    if (imageSlideIndex > 0) {
                                        setImageSlideIndex(imageSlideIndex - 1)
                                    } else {
                                        setImageSlideIndex(0)
                                    }
                                }}><i className='fas fa-chevron-left'></i></button>
                            <div className={css.dots}>
                                {
                                    images.map((item, index) => {
                                        return <span className={imageSlideIndex === index ? css.activeDot : ""} key={index}></span>
                                    })
                                }
                            </div>
                            <button
                                className={css.navBtn}
                                onClick={() => {
                                    if (imageSlideIndex < images.length - 1) {
                                        setImageSlideIndex(imageSlideIndex + 1)
                                    } else {
                                        setImageSlideIndex(images.length - 1)
                                    }
                                }}
                            ><i className='fas fa-chevron-right'></i></button>
                        </div>
                        }
                    </div>
                    {selectedProduct?.metadata?.reference && selectedProduct?.metadata?.reference?.some((item) => isValidURL(item)) &&
                        <div className={css.col}>
                            <h4>References</h4>
                            {
                                selectedProduct?.metadata?.reference?.map((item, index) => {
                                    if (isValidURL(item)) {
                                        return <a href={item.includes("https") ? item : `https://${item}`} target="_blank" key={index}>{item}</a>
                                    }
                                })}
                        </div>
                    }
                </>
            </div>
            <div className={`${css.purchaseContainer} ${!selectedProduct?.metadata?.thermofisher_link ? css.cartContainer : ''}`}>
                {selectedProduct?.metadata?.thermofisher_link ?
                 <>
                    <p>Purchase though our industry partner:</p>
                    <a href={selectedProduct?.metadata?.thermofisher_link} className={css.btn} target="_blank"
                        onClick={() => {
                            const data = {
                                product_id: selectedProduct?.id,
                                cat_id: `${selectedProduct?.mid_code} ${selectedProduct?.material}`,
                                product_name: selectedProduct?.title,
                                thermo_link: selectedProduct?.metadata?.thermofisher_link
                            }
                            mixPanelEvent('thermo', data)
                            mixPanelServerEvent('thermo', data)
                            gtagViewDownloadEvent('thermo', data)
                        }}>Thermofisher</a>
                </>
                :
                <button className={css.cartBtn} onClick={() => AddToCart(selectedProduct)}>Add to Cart</button>
                }
            </div>
            <ReactTooltip
                id="applications"
                place="top"
                variant="light"
            />
        </div>
    )
}